import { useState, useEffect } from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import ChiSiamoSection from "@/components/ChiSiamoSection";
import MenuSection from "@/components/MenuSection";
import GalleriaSection from "@/components/GalleriaSection";
import InstagramSection from "@/components/InstagramSection";
import DoveSiamoSection from "@/components/DoveSiamoSection";
import ContattiSection from "@/components/ContattiSection";
import Footer from "@/components/Footer";

// import InitialOverlay from "@/components/InitialOverlay";
import { useComponentLoader } from "@/hooks/useComponentLoader";

const Index = () => {
  const [hasError, setHasError] = useState(false);
  const { isLoaded: assetsLoaded, retry: retryAssets } = useComponentLoader({ maxRetries: 3 });

  // Se gli asset non si caricano, mostra un messaggio di errore con retry
  if (hasError && !assetsLoaded) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-4">Errore di caricamento</h2>
          <p className="text-gray-600 mb-4">Si è verificato un errore nel caricamento della pagina.</p>
          <div className="space-x-4">
            <button 
              onClick={() => {
                setHasError(false);
                retryAssets();
              }} 
              className="px-6 py-2 bg-gold text-white rounded-lg hover:bg-gold/90"
            >
              Riprova
            </button>
            <button 
              onClick={() => window.location.reload()} 
              className="px-6 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600"
            >
              Ricarica pagina
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <ChiSiamoSection />
        <MenuSection />
        <GalleriaSection />
        <InstagramSection />
        <DoveSiamoSection />
        <ContattiSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
